import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import EmpresaBannerSlot from 'frontend/features/banners/components/EmpresaBannerSlot';
import SlickCarouselArrow from '../SlickCarouselArrow/index';
import 'styles/components/SlickCarousel.css';
import { useEffect, useRef } from 'react';
import { useIsMobileBelowMd } from 'legacyfrontend/hooks/useMatchMedia';

const SlickCarousel = ({ data, itemsPerPage }) => {
  const { banner } = data;
  const sliderRef = useRef(null);
  const isMobile = useIsMobileBelowMd();

  useEffect(() => {
    return () => {
      if (sliderRef.current) {
        sliderRef.current.slickGoTo(0);
      }
    };
  }, []);

  const slidesToShow = isMobile ? 1 : itemsPerPage;

  const settings = {
    dots: true,
    infinite: false,
    slidesToShow,
    slidesToScroll: 1,
    touchThreshold: 100,
    prevArrow: <SlickCarouselArrow side='left' />,
    nextArrow: <SlickCarouselArrow side='right' />,
  };

  return (
    <div className='slider-container banners-slider'>
      <Slider key={isMobile ? 'mobile' : 'desktop'} ref={sliderRef} {...settings}>
        {banner
          .slice()
          .sort((a, b) => (a.orden === b.orden ? 0 : a.orden > b.orden ? 1 : -1))
          .map((bannerData) => (
            <EmpresaBannerSlot key={bannerData.id} data={bannerData} />
          ))}
      </Slider>
    </div>
  );
};

export default SlickCarousel;
